import { useMemo } from 'react'
import { DataQualityCheckColumnSelectionTableProps } from './DataQuality.types'
import { GridColDef } from '@mui/x-data-grid'
import { Box, Typography } from '@mui/material'
import { Table } from 'Common/MUITable/MUITable'
import { autoHeightInModal } from 'Common/utils/utils'
import {
  useGridApiRef,
  GridToolbarContainer,
  GridToolbarExport,
} from '@mui/x-data-grid-premium'
import { Loader } from 'Common/Loader/Loader'
import { columnDefinitions } from './DataQualityColumnDefinitions'

const CustomToolbar = ({
  column,
  dataExists,
}: {
  column: string
  dataExists: boolean
}) => {
  return () => (
    <GridToolbarContainer>
      {dataExists && (
        <GridToolbarExport
          excelOptions={{
            allColumns: true,
            fileName: `data-quality-check_${column}`,
          }}
          slotProps={{
            tooltip: { title: 'Download data' },
            button: { variant: 'outlined' },
          }}
        />
      )}
    </GridToolbarContainer>
  )
}

export const DataQualityColumnSelectionMUITable = ({
  isLoading,
  data,
  column,
}: DataQualityCheckColumnSelectionTableProps) => {
  const apiRef = useGridApiRef()
  const columns: GridColDef[] = useMemo(() => {
    if (column) {
      return columnDefinitions[column]
    }
    return []
  }, [data])

  if (isLoading) {
    return <Loader />
  }
  const dataExists = data && data.length > 0

  if (!dataExists) {
    return (
      <Box>
        <Typography>No Data available</Typography>
      </Box>
    )
  }

  return (
    <Box>
      <Box
        id="#table-modal-container-mui"
        sx={{
          '& .red-column': {
            color: '#FF0000',
          },
        }}
      >
        <Table
          localeText={{
            toolbarExport: 'Download',
          }}
          loading={isLoading}
          rowHeight={25}
          getRowId={(row) => row.index}
          ref={autoHeightInModal}
          apiRef={apiRef}
          rows={data ?? []}
          columns={columns}
          showCellVerticalBorder
          showColumnVerticalBorder
          pagination
          initialState={{
            pagination: { paginationModel: { pageSize: 100 } },
          }}
          pageSizeOptions={[25, 50, 100]}
          experimentalFeatures={{
            lazyLoading: true,
          }}
          slots={{
            toolbar: CustomToolbar({ column, dataExists }),
          }}
        />
      </Box>
    </Box>
  )
}
